'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'house';
var width = 576;
var height = 512;
var aliases = [127968,63498,63500,"home","home-alt","home-lg-alt"];
var unicode = 'f015';
var svgPathData = 'M288.4-8.8l16 14.4 232 208 17.9 16-32 35.7c-13.6-12.2-22.2-19.9-25.8-23.2l0 269.3-416 0 0-269.3c-3.7 3.3-12.3 11-25.8 23.2l-32-35.7 17.9-16 232-208 16-14.4zm0 64.5l-160 143.5 0 264.3 64 0 0-176 192 0 0 176 64 0 0-264.3-160-143.4zm-48 407.8l96 0 0-128-96 0 0 128z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouse = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;